import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Constant, { getCurrency } from '../../Constant.js'
import axios from 'axios'
import Swal from 'sweetalert2'
import Button from '../../common/CustomComponents/Button.js'
class CruiseTripDetails extends Component {
  state = {
    cruiseTripData: [],
    isLoading: false,
  }

  myStyle = {
    fontWeight: 'bold',
  }

  StyleForDetail = {
    marginBottom: '6px',
    letterSpacing: '0.5px',
    display: 'inline-block',
  }

  componentDidMount() {
    this.getCruiseTripData()

    let country = localStorage.getItem('countryShortName')

    this.setState({ currency: getCurrency(country) })
  }

  getCruiseTripData = async () => {
    const tripId = this.props.match?.params?.id
    this.setState({ isLoading: true })
    await axios
      .get(Constant.getAPI() + `/trips/get-cruise-trip-details/${tripId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          this.setState({
            cruiseTripData: res?.data?.data,
          })
          this.setState({ isLoading: false })
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteItem = (id) => {
    Swal.fire({
      title: 'Delete',
      text: 'Are you sure?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(Constant.getAPI() + `/trips/delete-cruise-trip/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then(() => {
            window.location.href = '#/cruise-trip/' + this.props.match?.params?.cruiseId
            window.location.reload()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      }
    })
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Cruise Trip Details</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/cruise-trip`}>
                          <i className="feather">Cruise Trip Lists</i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Cruise Trip Details</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div
                        className="row"
                        style={{ padding: '0 10px 15px 10px', borderBottom: '1px solid #ddd' }}
                      >
                        <Button to={`/cruise-trip/add/${this.props.match?.params?.id}`}>Edit</Button>
                        <Button onClick={this.deleteItem.bind(this, this.props.match?.params?.id)}>Delete</Button>
                        <Button to={`/gallary-list/trip/${this.props.match?.params?.id}`}>Gallery</Button>
                        <Button to={`/cruise-trip-slots/${this.props.match?.params?.id}`}>Slots</Button>
                        <Button to={`/cruise-trip-itinerary/${this.props.match?.params?.id}`}>Itinerary</Button>
                        <Button
                          to={`/cruise-trip-cabin-price/${this.props.match?.params?.id}/${this.state.cruiseTripData?.cruises?.[0]}`}
                        >
                          Cabin & Price
                        </Button>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div className="row">
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Cruise Trip Details</div>
                            </div>
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>ID</div>
                            </div>
                            <div className="col-5">
                              <div style={{ color: 'red', fontWeight: 'bold' }}>
                                {this.state.cruiseTripData?.id || '--'}
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div></div>
                            </div>
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Name: English</div>
                              <div>Name: Arabic</div>
                              <div>Departure Location</div>
                              <div>Arrival Location</div>
                              <div>Display Amount</div>
                            </div>
                            <div className="col-5">
                              <div>{this.state.cruiseTripData?.name_en || '--'}</div>
                              <div>{this.state.cruiseTripData?.name_ar || '--'}</div>
                              <div>{this.state.cruiseTripData?.departure_location || '--'}</div>
                              <div>{this.state.cruiseTripData?.arrival_location || '--'}</div>
                              <div>{this.state.cruiseTripData?.display_amount || '--'}</div>
                              <div style={{ height: 50 }}>
                                <img
                                  src={
                                    this.state.cruiseTripData?.img_en &&
                                    typeof this.state.cruiseTripData?.img_en == 'string'
                                      ? Constant.getImage() + this.state.cruiseTripData?.img_en
                                      : './assets/images/no_image.png'
                                  }
                                  className="img-fluid"
                                  alt="img"
                                  onError={(event) => {
                                    event.currentTarget.src = './assets/images/no_image.png'
                                  }}
                                  style={{ height: 40, border: '1px solid #aaa', borderRadius: 5 }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Details: English</div>
                              <div>Details: Arabic</div>
                            </div>
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            ></div>
                            <div className="col-5">
                              <div>{this.state.cruiseTripData?.details_en || '--'}</div>
                              <div>{this.state.cruiseTripData?.details_ar || '--'}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Description: English</div>
                            </div>
                            <div className="col-9">
                              <div dangerouslySetInnerHTML={{ __html: this.state.cruiseTripData?.desc_en }}></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Description: Arabic</div>
                            </div>
                            <div className="col-9">
                              <div dangerouslySetInnerHTML={{ __html: this.state.cruiseTripData?.desc_ar }}></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Refund Policy: English</div>
                            </div>
                            <div className="col-9">
                              <div
                                dangerouslySetInnerHTML={{ __html: this.state.cruiseTripData?.refund_policy_en }}
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Refund Policy: Arabic</div>
                            </div>
                            <div className="col-9">
                              <div
                                dangerouslySetInnerHTML={{ __html: this.state.cruiseTripData?.refund_policy_ar }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Cruise Trip Policy: English</div>
                            </div>
                            <div className="col-9">
                              <div dangerouslySetInnerHTML={{ __html: this.state.cruiseTripData?.policy_en }}></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Cruise Trip Policy: Arabic</div>
                            </div>
                            <div className="col-9">
                              <div dangerouslySetInnerHTML={{ __html: this.state.cruiseTripData?.policy_ar }}></div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CruiseTripDetails
